import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Magic Quote',
        projectDesc: 'An autonomous qoute generator of random famous personalities also allow user to create and upload its own qoutes.',
        tags: ['React', 'CSS', 'Material Ui'],
        code: 'https://github.com/shmazaovais/Magic_Quote-update',
        demo: 'https://github.com/shamzaovais/Magic_Qoute-update',
        image: one
    },
    {
        id: 2,
        projectName: 'Railway Tracking',
        projectDesc: 'This project is a railway tracking system that allows users to obtain relevant information about train timing.',
        tags: ['Django', 'Tailwind CSS'],
        code: 'https://github.com/shamzaovais/my-portfolio',
        demo: 'https://github.com/shamzaovais/my-portfolio',
        image: two
    },
    {
        id: 3,
        projectName: 'Weather App',
        projectDesc: 'Weather forecast systems and applications predict weather conditions based on multiple parameters.',
        tags: ['Django', 'CSS', 'Material Ui'],
        code: 'https://github.com/shamzaovais/my-portfolio',
        demo: 'https://github.com/shamzaovais/my-portfolio',
        image: three
    },
    {
        id: 4,
        projectName: 'Muslim App',
        projectDesc: 'An Islamic value app for prayer timing and Quran recitation.',
        tags: ['Flutter', 'Firebase'],
        code: 'https://github.com/shamzaovais/deen_quran_app',
        demo: 'https://github.com/shamzaovais/deen_quran_app',
        image: four
    },
    {
        id: 5,
        projectName: 'Bead 12',
        projectDesc: 'A 12 bead board game application',
        tags: ['Kotlin', 'Unity', 'C#'],
        code: 'https://github.com/shamzaovais/12Bead',
        demo: 'https://github.com/shamzaovais/12Bead',
        image: five
    },
    {
        id: 6,
        projectName: 'Crop Disease Detection',
        projectDesc: 'Crop disease detection model to help farmers identify, manage crop diseases and improves agriculture productivity.',
        tags: ['Tensorflow', 'Python', 'Deep Learning'],
        code: 'https://github.com/shamzaovais/crop_disease_detection',
        demo: 'https://github.com/shamzaovais/crop_disease_detection',
        image: six
    },
    {
        id: 7,
        projectName: 'Digit Recognition Model',
        projectDesc: 'A 7segment digit recognization model thats converst the data to create an csv file ',
        tags: ['Python', 'Numpy', 'CNN'],
        code: 'https://github.com/shamzaovais/seven_segment_digit_recognition',
        demo: 'https://github.com/shamzaovais/seven_segment_digit_recognition',
        image: seven
    },
    {
        id: 8,
        projectName: 'Quiz App',
        projectDesc: 'A quiz app that allows users to test their knowledge on various topics and compete with friends.',
        tags: ['Flutter', 'React'],
        code: 'https://github.com/shamzaovais/quiz_app',
        demo: 'https://github.com/shamzaovais/quiz_app',
        image: eight
    },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/